import {Component, Input} from '@angular/core';
import {LoadingSpinnerComponent} from '../loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-card',
  imports: [
    LoadingSpinnerComponent
  ],
  template: '@if (loading) {<app-loading-spinner/>}<ng-content></ng-content>',
  styleUrl: './card.component.scss'
})
export class CardComponent {
  @Input() loading = false;
}
